import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";
import { CommentDataProps } from "./useGetConsoleQrSystemDetail";

interface DetialRequest {
    category: string;
    list_no: string;
}
export interface BillInquiryDetailResponse {
    // statusCode: number;
    // message: string;
    // data: {
    flag: boolean;
    list_no: number;
    bl_no: string;
    subject: string;
    contents: string;
    company: string;
    m_email: string;
    mobile: string;
    w_date: string;
    comment: CommentDataProps[];
    // };
}

export const useGetConsoleBillInquiryDetail = ({ category, list_no }: DetialRequest): UseQueryResult<BillInquiryDetailResponse, Error> => {
    let url = enum_api_uri.get_console_bill_detail.replace(":category", category).replace(":list_no", list_no);
    return useQuery({
        queryKey: ["useGetConsoleBillInquiryDetail", category, list_no],
        queryFn: async () => {
            const response = await axiosInstance.get(
                url,
                //     {
                //     params: {
                //         category,
                //         list_no,
                //     },
                // }
            );
            return response.data.data;
        },
        enabled: !!category && !!list_no,
    });
};
